import axios from "axios";
import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchStatus, setFetchStatus] = useState(true);
  const [searchStatus, setSearchStatus] = useState(true);
  const [currentId, setCurrentId] = useState(null);
  const [input, setInput] = useState({
    title: "",
    job_description: "",
    company_image_url: "",
    job_qualification: "",
    job_type: "",
    job_tenure: "",
    job_status: 0,
    company_name: "",
    company_city: "",
    salary_min: 0,
    salary_max: 0,
  });
  const [title, settitle] = useState("");
  const [job_description, setjob_description] = useState("");
  const [company_image_url, setcompany_image_url] = useState("");
  const [job_qualification, setjob_qualification] = useState("");
  const [job_type, setjob_type] = useState("");
  const [job_tenure, setjob_tenure] = useState("");
  const [job_status, setjob_status] = useState(0);
  const [company_name, setcompany_name] = useState("");
  const [company_city, setcompany_city] = useState("");
  const [salary_min, setsalary_min] = useState(0);
  const [salary_max, setsalary_max] = useState(0);
  const fetchData = async () => {
    setIsLoading(true);
    try {
      let result = await axios.get(
        `https://dev-example.sanbercloud.com/api/job-vacancy`
      );
      let fetchResult = result.data.data;
      console.log(fetchResult);
      setData(
        fetchResult.map((res) => {
          return {
            id: res.id,
            title: res.title,
            job_description: res.job_description,
            company_image_url: res.company_image_url,
            job_qualification: res.job_qualification,
            job_type: res.job_type,
            job_tenure: res.job_tenure,
            job_status: res.job_status,
            company_name: res.company_name,
            company_city: res.company_city,
            salary_min: res.salary_min,
            salary_max: res.salary_max,
            created_at: res.created_at,
          };
        })
      );
      setIsLoading(false);
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: '<a href="">Why do I have this issue?</a>',
      });
    }
  };

  const functionSubmit = () => {
    console.log(input);
    axios
      .post(`https://dev-example.sanbercloud.com/api/job-vacancy/`, {
        category: input.category,
        description: input.description,
        image_url: input.image_url,
        is_android_app: input.is_android_app,
        is_ios_app: input.is_ios_app,
        name: input.name,
        price: input.price,
        rating: input.rating,
        release_year: input.release_year,
        size: input.size,
      })
      .then((res) => {
        console.log(res);
        setFetchStatus(true);
        navigate("/manage-data");
      })
      .catch((e) => {
        console.log(e.response.data.message);
        alert(e.response.data.message);
      });
  };

  const functionUpdate = () => {
    axios
      .put(`https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`, {
        title: input.title,
        job_description: input.job_description,
        company_image_url: input.company_image_url,
        job_qualification: input.job_qualification,
        job_type: input.job_type,
        job_tenure: input.job_tenure,
        job_status: input.job_status,
        company_name: input.company_name,
        company_city: input.company_city,
        salary_min: input.salary_min,
        salary_max: input.salary_max,
      })
      .then((e) => {
        setFetchStatus(true);
        navigate("/manage-data");
      });
  };

  const functionEdit = (IdData) => {
    axios
      .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`)
      .then((result) => {
        let fetchResult = result.data;
        settitle(fetchResult.title);
        setjob_description(fetchResult.job_description);
        setcompany_image_url(fetchResult.company_image_url);
        setjob_qualification(fetchResult.job_qualification);
        setjob_type(fetchResult.job_type);
        setjob_tenure(fetchResult.job_tenure);
        setjob_status(fetchResult.job_status);
        setcompany_name(fetchResult.company_name);
        setcompany_city(fetchResult.company_city);
        setsalary_min(fetchResult.salary_min);
        setsalary_max(fetchResult.salary_max);
        setCurrentId(fetchResult.id);
      })
      .finally(setIsLoading(false));
  };

  const functionDelete = (idMobile) => {
    axios
      .delete(`https://dev-example.sanbercloud.com/api/job-vacancy/${idMobile}`)
      .then(() => {
        setFetchStatus(true);
      });
  };

  const handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let platform = ["is_android_app", "is_ios_app"];

    if (platform.indexOf(name) === -1) {
      setInput({ ...input, [name]: value });
    } else {
      setInput({ ...input, [name]: !input[name] });
    }
  };

  const handleText = (params, max) => {
    if (params === undefined) {
      return "";
    } else {
      return params.slice(0, max) + "...";
    }
  };

  const functions = {
    functionDelete,
    functionEdit,
    fetchData,
    handleChange,
    functionSubmit,
    functionUpdate,
    handleText,
  };

  return (
    <GlobalContext.Provider
      value={{
        data,
        setData,
        fetchStatus,
        setFetchStatus,
        searchStatus,
        setSearchStatus,
        currentId,
        setCurrentId,
        input,
        isLoading,
        setIsLoading,
        setInput,
        functions,
        title,
        settitle,
        job_description,
        setjob_description,
        company_image_url,
        setcompany_image_url,
        job_qualification,
        setjob_qualification,
        job_type,
        setjob_type,
        job_tenure,
        setjob_tenure,
        job_status,
        setjob_status,
        company_name,
        setcompany_name,
        company_city,
        setcompany_city,
        salary_min,
        setsalary_min,
        salary_max,
        setsalary_max,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};
